// Import your construction images
import omer1 from '../Images/omermasjid/omer (1).jpg';
import omer2 from '../Images/omermasjid/omer (2).jpg';
import omer4 from '../Images/omermasjid/omer (4).jpg';
import omer5 from '../Images/omermasjid/omer (5).jpg';
import omer6 from '../Images/omermasjid/omer (6).jpg';
import omer7 from '../Images/omermasjid/omer (7).jpg';
import omer8 from '../Images/omermasjid/omer (8).jpg';
import omer9 from '../Images/omermasjid/omer (9).jpg';
import omer10 from '../Images/omermasjid/omer (10).jpg';
import omer11 from '../Images/omermasjid/omer (11).jpg';
import omer12 from '../Images/omermasjid/omer (12).jpg';
import omer13 from '../Images/omermasjid/omer (13).jpg';
import omer14 from '../Images/omermasjid/omer (14).jpg';
import omer15 from '../Images/omermasjid/omer (15).jpg';
import omer16 from '../Images/omermasjid/omer (16).jpg';
import omer17 from '../Images/omermasjid/omer (17).jpg';
// import omer18 from '../Images/omermasjid/omer (18).jpg';
import omer19 from '../Images/omermasjid/omer (19).jpg';
import omer20 from '../Images/omermasjid/omer (20).jpg';
import omer21 from '../Images/omermasjid/omer (21).jpg';
import omer22 from '../Images/omermasjid/omer (22).jpg';
import omer23 from '../Images/omermasjid/omer (23).jpg';
import omer24 from '../Images/omermasjid/omer (24).jpg';
import omer25 from '../Images/omermasjid/omer (25).jpg';
import omer26 from '../Images/omermasjid/omer (26).jpg';
import omer27 from '../Images/omermasjid/omer (27).jpg';
import omer28 from '../Images/omermasjid/omer (28).jpg';
import omer29 from '../Images/omermasjid/omer (29).jpg';
import omer30 from '../Images/omermasjid/omer (30).jpg';
import omer31 from '../Images/omermasjid/omer (31).jpg';
import omer32 from '../Images/omermasjid/omer (32).jpg';


//------------------------------------------------------------------

import ans1 from '../Images/ansarullah-workflow/ans (1).jpg';
import ans2 from '../Images/ansarullah-workflow/ans (2).jpg';
import ans3 from '../Images/ansarullah-workflow/ans (3).jpg';
import ans4 from '../Images/ansarullah-workflow/ans (4).jpg';
import ans5 from '../Images/ansarullah-workflow/ans (5).jpg';
import ans6 from '../Images/ansarullah-workflow/ans (6).jpg';
import ans7 from '../Images/ansarullah-workflow/ans (7).jpg';
import ans8 from '../Images/ansarullah-workflow/ans (8).jpg';
import ans9 from '../Images/ansarullah-workflow/ans (9).jpg';
import ans10 from '../Images/ansarullah-workflow/ans (10).jpg';
import ans11 from '../Images/ansarullah-workflow/ans (11).jpg';
import ans12 from '../Images/ansarullah-workflow/ans (12).jpg';
import ans13 from '../Images/ansarullah-workflow/ans (13).jpg';
import ans14 from '../Images/ansarullah-workflow/ans (14).jpg';
import ans15 from '../Images/ansarullah-workflow/ans (15).jpg';
import ans16 from '../Images/ansarullah-workflow/ans (16).jpg';
import ans17 from '../Images/ansarullah-workflow/ans (17).jpg';
import ans18 from '../Images/ansarullah-workflow/ans (18).jpg';
import ans19 from '../Images/ansarullah-workflow/ans (19).jpg';
import ans20 from '../Images/ansarullah-workflow/ans (20).jpg';
import ans21 from '../Images/ansarullah-workflow/ans (21).jpg';
import ans22 from '../Images/ansarullah-workflow/ans (22).jpg';
import ans23 from '../Images/ansarullah-workflow/ans (23).jpg';
import ans24 from '../Images/ansarullah-workflow/ans (24).jpg';
import ans25 from '../Images/ansarullah-workflow/ans (25).jpg';
import ans26 from '../Images/ansarullah-workflow/ans (26).jpg';
import ans27 from '../Images/ansarullah-workflow/ans (27).jpg';
import ans28 from '../Images/ansarullah-workflow/ans (28).jpg';
import ans29 from '../Images/ansarullah-workflow/ans (29).jpg';
import ans30 from '../Images/ansarullah-workflow/ans (30).jpg';
import ans31 from '../Images/ansarullah-workflow/ans (31).jpg';
import ans32 from '../Images/ansarullah-workflow/ans (32).jpg';
import ans33 from '../Images/ansarullah-workflow/ans (33).jpg';
import ans34 from '../Images/ansarullah-workflow/ans (34).jpg';
import ans35 from '../Images/ansarullah-workflow/ans (35).jpg';

//--------------------------------------------------------------------
 import abu1 from '../Images/abubakar/abu (1).jpg';
  import abu2 from '../Images/abubakar/abu (2).jpg';
   import abu3 from '../Images/abubakar/abu (3).jpg';
    import abu4 from '../Images/abubakar/abu (4).jpg';
     import abu5 from '../Images/abubakar/abu (5).jpg';
      import abu6 from '../Images/abubakar/abu (6).jpg';
       import abu7 from '../Images/abubakar/abu (7).jpg';

//------------------------------------------------------------------------



//---------------------------------------------------------------------

import water1 from '../Images/water/water (1).jpg';
import water2 from '../Images/water/water (2).jpg';
import water3 from '../Images/water/water (3).jpg';
import water4 from '../Images/water/water (4).jpg';
import water5 from '../Images/water/water (5).jpg';
import water6 from '../Images/water/water (6).jpg';
import water7 from '../Images/water/water (7).jpg';
import water8 from '../Images/water/water (8).jpg';
import water9 from '../Images/water/water (9).jpg';
import water10 from '../Images/water/water (10).jpg';
import water11 from '../Images/water/water (11).jpg';
import water12 from '../Images/water/water (12).jpg';
import water13 from '../Images/water/water (13).jpg';
import water14 from '../Images/water/water (14).jpg';
import water15 from '../Images/water/water (15).jpg';
import water16 from '../Images/water/water (16).jpg';
import water17 from '../Images/water/water (17).jpg';
import water18 from '../Images/water/water (18).jpg';
import water19 from '../Images/water/water (19).jpg';

//--------------------------------------------------------------------------

import newAns1 from '../Images/New ansarullah/newAns (1).jpg';
import newAns2 from '../Images/New ansarullah/newAns (2).jpg';
import newAns3 from '../Images/New ansarullah/newAns (3).jpg';
import newAns4 from '../Images/New ansarullah/newAns (4).jpg';
import newAns5 from '../Images/New ansarullah/newAns (5).jpg';
import newAns6 from '../Images/New ansarullah/newAns (6).jpg';
import newAns7 from '../Images/New ansarullah/newAns (7).jpg';
import newAns8 from '../Images/New ansarullah/newAns (8).jpg';
import newAns9 from '../Images/New ansarullah/newAns (9).jpg';
import newAns10 from '../Images/New ansarullah/newAns (10).jpg';
import newAns11 from '../Images/New ansarullah/newAns (11).jpg';
import newAns12 from '../Images/New ansarullah/newAns (12).jpg';
import newAns13 from '../Images/New ansarullah/newAns (13).jpg';
import newAns14 from '../Images/New ansarullah/newAns (14).jpg';
import newAns15 from '../Images/New ansarullah/newAns (15).jpg';
import newAns16 from '../Images/New ansarullah/newAns (16).jpg';
import newAns17 from '../Images/New ansarullah/newAns (17).jpg';
import newAns18 from '../Images/New ansarullah/newAns (18).jpg';
import newAns19 from '../Images/New ansarullah/newAns (19).jpg';
import newAns20 from '../Images/New ansarullah/newAns (20).jpg';
import newAns21 from '../Images/New ansarullah/newAns (21).jpg';
import newAns22 from '../Images/New ansarullah/newAns (22).jpg';
import newAns23 from '../Images/New ansarullah/newAns (23).jpg';
import newAns24 from '../Images/New ansarullah/newAns (24).jpg';
import newAns25 from '../Images/New ansarullah/newAns (25).jpg';
import newAns26 from '../Images/New ansarullah/newAns (26).jpg';
import newAns27 from '../Images/New ansarullah/newAns (27).jpg';
import newAns28 from '../Images/New ansarullah/newAns (28).jpg';
import newAns29 from '../Images/New ansarullah/newAns (29).jpg';
import newAns30 from '../Images/New ansarullah/newAns (30).jpg';
import newAns31 from '../Images/New ansarullah/newAns (31).jpg';
import newAns32 from '../Images/New ansarullah/newAns (32).jpg';
import newAns33 from '../Images/New ansarullah/newAns (33).jpg';
import newAns34 from '../Images/New ansarullah/newAns (34).jpg';
import newAns35 from '../Images/New ansarullah/newAns (35).jpg';
import newAns36 from '../Images/New ansarullah/newAns (36).jpg';
import newAns37 from '../Images/New ansarullah/newAns (37).jpg';
import newAns38 from '../Images/New ansarullah/newAns (38).jpg';
import newAns39 from '../Images/New ansarullah/newAns (39).jpg';
import newAns40 from '../Images/New ansarullah/newAns (40).jpg';
import newAns41 from '../Images/New ansarullah/newAns (41).jpg';
import newAns42 from '../Images/New ansarullah/newAns (42).jpg';
import newAns43 from '../Images/New ansarullah/newAns (43).jpg';
import newAns44 from '../Images/New ansarullah/newAns (44).jpg';
import newAns45 from '../Images/New ansarullah/newAns (45).jpg';
import newAns46 from '../Images/New ansarullah/newAns (46).jpg';
import newAns47 from '../Images/New ansarullah/newAns (47).jpg';
import newAns48 from '../Images/New ansarullah/newAns (48).jpg';
import newAns49 from '../Images/New ansarullah/newAns (49).jpg';
import newAns50 from '../Images/New ansarullah/newAns (50).jpg';
import newAns51 from '../Images/New ansarullah/newAns (51).jpg';
import newAns52 from '../Images/New ansarullah/newAns (52).jpg';
import newAns53 from '../Images/New ansarullah/newAns (53).jpg';
import newAns54 from '../Images/New ansarullah/newAns (54).jpg';
import newAns55 from '../Images/New ansarullah/newAns (55).jpg';

//--------------------------------------------------------------

import cli1 from '../Images/Clinic 2/cli (1).jpg';
import cli2 from '../Images/Clinic 2/cli (2).jpg';
import cli3 from '../Images/Clinic 2/cli (3).jpg';
import cli4 from '../Images/Clinic 2/cli (4).jpg';
import cli5 from '../Images/Clinic 2/cli (5).jpg';
import cli6 from '../Images/Clinic 2/cli (6).jpg';
import cli7 from '../Images/Clinic 2/cli (7).jpg';
import cli8 from '../Images/Clinic 2/cli (8).jpg';
import cli9 from '../Images/Clinic 2/cli (9).jpg';
import cli10 from '../Images/Clinic 2/cli (10).jpg';
import cli11 from '../Images/Clinic 2/cli (11).jpg';
import cli12 from '../Images/Clinic 2/cli (12).jpg';
import cli13 from '../Images/Clinic 2/cli (13).jpg';
import cli14 from '../Images/Clinic 2/cli (14).jpg';


export const constructionImages = {
  buildings: {
    title: 'Omer Farooq Masjid',
    images: [
      
    //   { id: 1, src: omer3 },
      { id: 1, src: omer1 },
      { id: 2, src: omer15 },
      { id: 3, src: omer5},
      { id: 4, src: omer4},
      { id: 5, src: omer6 },
      { id: 6, src: omer7 },
      { id: 7, src: omer8 },
      { id: 8, src: omer9 },
      { id: 9, src: omer10 },
      { id: 10, src: omer11 },
      { id: 11, src: omer12 },
      { id: 12, src: omer13 },
      { id: 13, src: omer14 },
      { id: 14, src: omer2 },
      { id: 15, src: omer16 },
       { id: 16, src: omer17 },
    //   { id: 17, src: omer18 },
      { id: 17, src: omer19 },
      { id: 18, src: omer20 },
      { id: 19, src: omer21 },
      { id: 20, src: omer22 },
      { id: 21, src: omer23 },
      { id: 22, src: omer24 },
       { id: 23, src: omer25 },
      { id: 24, src: omer26 },
      { id: 25, src: omer27 },
      { id: 26, src: omer28 },
      { id: 28, src: omer29 },
       { id: 29, src: omer30 },
        { id: 30, src: omer31 },
         { id: 31, src: omer32 }
     
    ]
  },
  infrastructure: {
    title: 'New Ansarullah School',
    images: [
     { id: 1, src: newAns16 },
  { id: 2, src: newAns20 },
  { id: 3, src: newAns3 },
  { id: 4, src: newAns4 },
  { id: 5, src: newAns5 },
  { id: 6, src: newAns6 },
  { id: 7, src: newAns7 },
  { id: 8, src: newAns8 },
  { id: 9, src: newAns9 },
  { id: 10, src: newAns10 },
  { id: 11, src: newAns11 },
  { id: 12, src: newAns12 },
  { id: 13, src: newAns13 },
  { id: 14, src: newAns14 },
  { id: 15, src: newAns15 },
  { id: 16, src: newAns1 },
  { id: 17, src: newAns17 },
  { id: 18, src: newAns18 },
  { id: 19, src: newAns19 },
  { id: 20, src: newAns2 },
  { id: 21, src: newAns21 },
  { id: 22, src: newAns22 },
  { id: 23, src: newAns23 },
  { id: 24, src: newAns24 },
  { id: 25, src: newAns25 },
  { id: 26, src: newAns26 },
  { id: 27, src: newAns27 },
  { id: 28, src: newAns28 },
  { id: 29, src: newAns29 },
  { id: 30, src: newAns30 },
  { id: 31, src: newAns31 },
  { id: 32, src: newAns32 },
  { id: 33, src: newAns33 },
  { id: 34, src: newAns34 },
  { id: 35, src: newAns35 },
  { id: 36, src: newAns36 },
  { id: 37, src: newAns37 },
  { id: 38, src: newAns38 },
  { id: 39, src: newAns39 },
  { id: 40, src: newAns40 },
  { id: 41, src: newAns41 },
  { id: 42, src: newAns42 },
  { id: 43, src: newAns43 },
  { id: 44, src: newAns44 },
  { id: 45, src: newAns45 },
  { id: 46, src: newAns46 },
  { id: 47, src: newAns47 },
  { id: 48, src: newAns48 },
  { id: 49, src: newAns49 },
  { id: 50, src: newAns50 },
  { id: 51, src: newAns51 },
  { id: 52, src: newAns52 },
  { id: 53, src: newAns53 },
  { id: 54, src: newAns54 },
  { id: 55, src: newAns55 }
    ]
  },
  interior: {
    title: 'Abu-Bakr Siddiq Masjid',
    images: [
     { id: 1, src: abu1},
      { id: 2, src: abu2},
       { id: 3, src: abu3},
        { id: 4, src: abu4},
         { id: 5, src: abu5},
          { id: 6, src: abu6},
           { id: 7, src: abu7},
    ]
  },
  interior2: {
    title: 'Ansarullah School Work Flow',
    images: [
       { id: 1, src: ans1},
       { id: 2, src: ans2},
       { id: 3, src: ans3},
       { id: 4, src: ans4},
       { id: 5, src: ans5},
       { id: 6, src: ans6},
       { id: 7, src: ans7},
       { id: 8, src: ans8},
       { id: 9, src: ans9},
       { id: 10, src: ans10},
       { id: 11, src: ans11},
       { id: 12, src: ans12},
       { id: 13, src: ans13},
       { id: 14, src: ans14},
       { id: 15, src: ans15},
       { id: 16, src: ans16},
       { id: 17, src: ans17},
       { id: 18, src: ans18},
       { id: 19, src: ans19},
       { id: 20, src: ans20},
       { id: 21, src: ans21},
       { id: 22, src: ans22},
       { id: 23, src: ans23},
       { id: 24, src: ans24},
       { id: 25, src: ans25},
       { id: 26, src: ans26},
       { id: 27, src: ans27},
       { id: 28, src: ans28},
       { id: 29, src: ans29},
       { id: 30, src: ans30},
       { id: 31, src: ans31},
       { id: 32, src: ans32},
       { id: 33, src: ans33},
       { id: 34, src: ans34},
       { id: 35, src: ans35},
    ]
  },
  heavy: {
    title: 'Water Supply Network',
    images: [
     { id: 1, src: water1 },
  { id: 2, src: water2 },
  { id: 3, src: water3 },
  { id: 4, src: water4 },
  { id: 5, src: water5 },
  { id: 6, src: water6 },
  { id: 7, src: water7 },
  { id: 8, src: water8 },
  { id: 9, src: water9 },
  { id: 10, src: water10 },
  { id: 11, src: water11 },
  { id: 12, src: water12 },
  { id: 13, src: water13 },
  { id: 14, src: water14 },
  { id: 15, src: water15 },
  { id: 16, src: water16 },
  { id: 17, src: water17 },
  { id: 18, src: water18 },
  { id: 19, src: water19 },
    ]
  },
  heavy2: {
    title: 'Saidabad District Clinic',
    images: [
       { id: 1, src: cli1 },
  { id: 2, src: cli2 },
  { id: 3, src: cli3 },
  { id: 4, src: cli4 },
  { id: 5, src: cli5 },
  { id: 6, src: cli6 },
  { id: 7, src: cli7 },
  { id: 8, src: cli8 },
  { id: 9, src: cli9 },
  { id: 10, src: cli10 },
  { id: 11, src: cli11 },
  { id: 12, src: cli12 },
  { id: 13, src: cli13 },
  { id: 14, src: cli14 }
    ]
    
  }
};